<!-- <div class="layout-sidebar" [ngStyle]="{'overflow':app.sidebarActive ? 'hidden' : 'visible'}" (click)="app.onSidebarClick($event)"> -->
<div class="layout-sidebar">
    <div class="layout-tabmenu">
        <ul class="layout-tabmenu-nav">
            <!-- <li [ngClass]="{'active-item':app.activeTabIndex === 0}"> -->
            <li>
                <!-- <a href="#" class="tabmenuitem-link" (click)="app.onTabClick($event, 0, true)"> -->
                <!-- <i class="fa fa-home"></i> -->
                <!-- </a> -->
                <!-- <div class="layout-tabmenu-tooltip">
                    <div class="layout-tabmenu-tooltip-arrow"></div>
                    <div class="layout-tabmenu-tooltip-text">Home</div>
                </div> -->
                <div class="clock" fxLayout="column" (click)="isLocalTime = !isLocalTime">
                    <!-- <span fxFlex="1 1 100%">{{weekLine}}</span>
                    <span fxFlex="1 1 100%">{{dateLine}}</span> -->
                    <span fxFlex="1 1 100%" [matTooltip]="clockToolTip" matTooltipPosition="right">{{timeLine}}</span>
                </div>
            </li>
        </ul>
        <app-home-sidebar-sh *ngIf="profileFamily === 'SURVIVAL_HORIZON'" [profileType]="profileType"></app-home-sidebar-sh>
        <app-home-sidebar-risk *ngIf="profileFamily === 'RISK_MANAGER'"></app-home-sidebar-risk>
        <app-home-sidebar-alm *ngIf="profileFamily === 'ALM'" [profileType]="profileType"></app-home-sidebar-alm>
        <app-home-sidebar-reporting *ngIf="profileType === 'REPORTING'" [profileType]="profileType"></app-home-sidebar-reporting>
        <app-home-sidebar-operations *ngIf="profileType === 'OPERATIONS'" [profileType]="profileType"></app-home-sidebar-operations>
    </div>
</div>